var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPlayPlayer = function SvgPlayPlayer(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 11.4738V7.10544C1 1.66455 4.90958 -0.558893 9.69681 2.16155L13.5532 4.35883L17.4096 6.55612C22.1968 9.27656 22.1968 13.7234 17.4096 16.4439L13.5532 18.6412L9.69681 20.8384C4.90958 23.5589 1 21.3355 1 15.8946V11.4738Z",
    fill: "#4239FB",
    stroke: "#4239FB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPlayPlayer);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjMiIHZpZXdCb3g9IjAgMCAyMiAyMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEgMTEuNDczOFY3LjEwNTQ0QzEgMS42NjQ1NSA0LjkwOTU4IC0wLjU1ODg5MyA5LjY5NjgxIDIuMTYxNTVMMTMuNTUzMiA0LjM1ODgzTDE3LjQwOTYgNi41NTYxMkMyMi4xOTY4IDkuMjc2NTYgMjIuMTk2OCAxMy43MjM0IDE3LjQwOTYgMTYuNDQzOUwxMy41NTMyIDE4LjY0MTJMOS42OTY4MSAyMC44Mzg0QzQuOTA5NTggMjMuNTU4OSAxIDIxLjMzNTUgMSAxNS44OTQ2VjExLjQ3MzhaIiBmaWxsPSIjNDIzOUZCIiBzdHJva2U9IiM0MjM5RkIiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";